import { useEffect, useState } from 'react';
import { useAppSelector } from '@application/store/useStore';
import { ClientContractStatus } from '@application/common/enums/client-contract-status';
import TimeSheetApi from '@infrastructure/timeSheet-api';
import UserContractApi from '@infrastructure/user-contract-api';
let cache = null;
const load = (userId) => Promise.all([
    TimeSheetApi.getTimeSheetCountsByStatus()
        .then((response) => response.data)
        .catch(() => undefined),
    UserContractApi.getMyUserContracts()
        .then((response) => response.data)
        .catch(() => undefined)
]).then(([timeSheetCounts, contracts]) => ({ userId, timeSheetCounts, contracts }));
const readCount = (counts, key) => {
    if (!counts)
        return undefined;
    const value = Object.entries(counts).find(([status]) => status === key)?.[1];
    return typeof value === 'number' ? value : 0;
};
export const useFreelancerTaskCounts = () => {
    const userId = useAppSelector((state) => state.auth.currentUser?.id);
    const storeCounts = useAppSelector((state) => state.timeSheet.timeSheetsCount);
    const storeContracts = useAppSelector((state) => state.userContract.userContracts);
    const [snapshot, setSnapshot] = useState(undefined);
    useEffect(() => {
        if (!userId) {
            cache = null;
            setSnapshot(undefined);
            return;
        }
        let active = true;
        if (!cache || cache.userId !== userId)
            cache = { userId, promise: load(userId) };
        cache.promise.then((value) => {
            if (active)
                setSnapshot(value);
        });
        return () => {
            active = false;
        };
    }, [userId]);
    const own = snapshot && snapshot.userId === userId ? snapshot : undefined;
    const timeSheetCounts = storeCounts ?? own?.timeSheetCounts;
    const contracts = storeContracts ?? own?.contracts;
    return {
        openTimeSheets: readCount(timeSheetCounts, 'Open'),
        rejectedTimeSheets: readCount(timeSheetCounts, 'Rejected'),
        documentsToSign: contracts ? contracts.filter((c) => c.status === ClientContractStatus.PendingSignature).length : undefined,
        isLoaded: own !== undefined || (storeCounts !== undefined && storeContracts !== undefined)
    };
};
